var moduleMap = {
	"./index": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_lumino_widgets-webpack_sharing_consume_default_jquery_jquery"), __webpack_require__.e("webpack_sharing_consume_default_lumino_coreutils"), __webpack_require__.e("webpack_sharing_consume_default_jupyter-widgets_base_jupyter-widgets_base"), __webpack_require__.e("webpack_sharing_consume_default_lumino_algorithm-webpack_sharing_consume_default_lumino_signaling"), __webpack_require__.e("lib_index_js")]).then(() => (() => ((__webpack_require__(/*! ./lib/index.js */ "./lib/index.js")))));
	},
	"./extension": () => {
		return Promise.all([__webpack_require__.e("webpack_sharing_consume_default_lumino_widgets-webpack_sharing_consume_default_jquery_jquery"), __webpack_require__.e("webpack_sharing_consume_default_lumino_coreutils"), __webpack_require__.e("webpack_sharing_consume_default_jupyter-widgets_base_jupyter-widgets_base"), __webpack_require__.e("webpack_sharing_consume_default_lumino_algorithm-webpack_sharing_consume_default_lumino_signaling"), __webpack_require__.e("lib_index_js")]).then(() => (() => ((__webpack_require__(/*! ./lib/index.js */ "./lib/index.js")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});